import axios from '@/axios.config.js';

class ProjectService {
    createProject(cancelToken, classId, data) {
        return axios
            .post(`classes/${classId}/projects`, {
                topic: data.topic,
                description: data.description,
                file_name: data.file_name,
                deadline_date: data.deadline_date,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateProject(cancelToken, classId, data) {
        return axios
            .patch(`classes/${classId}/projects/${data.id}`, {
                topic: data.topic,
                description: data.description,
                file_name: data.file_name,
                deadline_date: data.deadline_date,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteProject(cancelToken, classId, projectId) {
        return axios
            .delete(`classes/${classId}/projects/${projectId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getProject(cancelToken, classId, projectId) {
        return axios
            .get(`classes/${classId}/projects/${projectId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listProjects(cancelToken, classId) {
        return axios
            .get(`classes/${classId}/projects`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listUserProjects(cancelToken) {
        return axios
            .get(`users/me/projects`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    submitProject(cancelToken, classId, projectId, data) {
        return axios
            .post(`classes/${classId}/projects/${projectId}/submit`, {
                description: data.description,
                file_name: data.file_name,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    submitted(cancelToken, classId, projectId) {
        return axios
            .get(`classes/${classId}/projects/${projectId}/submitted`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new ProjectService();